// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/resource_explorer.actions.go

export const GET_ASSESSMENT_RESULTS =
  "mondoo.policy.ResourceExplorer.GetAssessmentResults";
